import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/edit-website";
import {Website} from "../bo/website";
import jQuery from "jquery";
import {Page} from "../bo/page";
import {Menu} from "../bo/menu";


const classname = "edit-website-view";

const NEW_PATH = "new-page";
const NEW_MENU = "New menu";

export class EditWebsiteView extends View {

    private readonly server = Server.instance();

    private website? : Website;

    constructor() {
        super(classname);
        this.load();
    }

    async load() {
        this.website = await this.server.website();
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.website) {
            return jQuery("<div>");
        }

        const pages = this.website.pages || [];
        const menus = this.website.menus || [];

        const newPageEnabled = pages.filter(p => p.path == NEW_PATH).length == 0;
        const newMenuEnabled = menus.filter(p => p.name == NEW_MENU).length == 0;

        const data = {
            pages: pages,
            newPageEnabled: newPageEnabled,
            menus: menus,
            newMenuEnabled: newMenuEnabled,
        };

        return this.pug(template, data);
    }

    newPage() {
        if (! this.website) {
            return;
        }

        const page : Page = {
            enabled: false,
            name: "New page",
            path: NEW_PATH,
            template: {
                "html": `<div class="responsive-page"><h1>New page - put content here</h1></div>`
            }
        };

        if (! this.website.pages) {
            this.website.pages = [];
        }
        this.website.pages.push(page);
        this.update();

        this.server.saveWebsite(this.website);
    }

    newMenu() {
        if (! this.website) {
            return;
        }

        const menu : Menu = {
            name: NEW_MENU,
            enabled: false,
            items: []
        };

        if (! this.website.menus) {
            this.website.menus = [];
        }
        this.website.menus.push(menu);
        this.update();

        this.server.saveWebsite(this.website);
    }
}

View.on(
    "." + classname,
    "click",
    ".add-page",
    function(that: EditWebsiteView, event, elt) {
        event.preventDefault();
        that.newPage();
    });

View.on(
    "." + classname,
    "click",
    ".add-menu",
    function(that: EditWebsiteView, event, elt) {
        event.preventDefault();
        that.newMenu();
    });





